<script setup lang="ts">
import type { Dictionary } from '@autobid/strapi-integration/typescript/webapi/Dictionary'
import type { MaxInColumn } from '@autobid/ui/utils/calcFormCheckboxGrid'
import { useDictionary } from '@autobid/ui/composables/useDictionary'
import { calcFormCheckboxGrid } from '@autobid/ui/utils/calcFormCheckboxGrid'
import { computed } from 'vue'
import SearchFormCheckbox from './SearchFormCheckbox.vue'

interface Props {
  dictionary: string[]
  label?: string
  maxInColumn?: MaxInColumn
}

const props = withDefaults(defineProps<Props>(), {
  label: undefined,
  maxInColumn: () => ({
    xs: 1,
    sm: 2,
    md: 4,
    lg: 5,
    xl: 6,
  }),
})

const { dictionary: entireDictionary, suspense } = useDictionary({ type: 'full' })
onServerPrefetch(suspense)

const items = computed(() => {
  if (!entireDictionary.value) {
    return {}
  }

  return props.dictionary.reduce((acc: Record<string, Dictionary>, key) => {
    acc[key] = entireDictionary.value![key]
    return acc
  }, {})
})

const itemsWrapperStyles = computed(() => {
  return calcFormCheckboxGrid({
    itemsLength: Object.keys(items.value || {}).length,
    maxInColumn: props.maxInColumn,
  })
})
</script>

<template>
  <div
    class="flex w-full flex-col items-end justify-end px-2"
    :style="itemsWrapperStyles"
  >
    <p class="pb-2 text-2xl font-semibold uppercase text-primary">
      {{ label }}
    </p>
    <div
      class="grid w-full grid-cols-[var(--xs-cols)] items-start justify-items-start gap-4 @sm-checkbox:grid-cols-[var(--sm-cols)] @md-checkbox:grid-cols-[var(--md-cols)] @lg-checkbox:grid-cols-[var(--lg-cols)] @xl-checkbox:grid-cols-[var(--xl-cols)]"
    >
      <SearchFormCheckbox
        v-for="item in items"
        :key="item.structureId"
        :item="item"
      />
    </div>
  </div>
</template>
